import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { user } from "@lhd/features/users/selector";
import { useFetchCurrentUserELearningPermissions } from "@lhd/hooks";

export type ReceivedProps = Record<string, any>;

const useElectronicLearningChart = (props: ReceivedProps) => {
  const [isShowNote, setIsShowNote] = useState(false);
  const [scale, setScale] = useState(1);

  const auth = useSelector(user);
  const isAdmin = !!auth?.is_admin;
  const { data: eLearningPermissionData } =
    useFetchCurrentUserELearningPermissions();
  const hasAddCoursePermission =
    isAdmin || !!eLearningPermissionData?.data?.add_new_course;
  const hasELearningListPermission =
    isAdmin ||
    !!eLearningPermissionData?.data?.general_course_read ||
    !!eLearningPermissionData?.data?.general_course_edit ||
    !!eLearningPermissionData?.data?.general_course_delete ||
    !!eLearningPermissionData?.data?.add_new_course;

  useEffect(() => {
    const el = document.getElementById("main-layout");
    if (!el) return;

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      const width = entry.contentRect.width - 10;
      const height = entry.contentRect.height - 40;

      const chartWidth = 1380;
      const chartHeight = 640;

      const scaleX = width / chartWidth;
      const scaleY = height / chartHeight;
      const calculatedScale = Math.min(scaleX, scaleY, 1);

      setScale(calculatedScale);
    });

    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return {
    ...props,
    isShowNote,
    setIsShowNote,
    scale,
    setScale,
    hasAddCoursePermission,
    hasELearningListPermission,
    isAdmin,
  };
};

export type Props = ReturnType<typeof useElectronicLearningChart>;
export default useElectronicLearningChart;
